import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchRouteView = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'searchRoutes',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, payload.params);
};

export default apiFetchRouteView;
